import { render, staticRenderFns } from "./PaymentChoice.vue?vue&type=template&id=304e7888&scoped=true&"
import script from "./PaymentChoice.vue?vue&type=script&lang=js&"
export * from "./PaymentChoice.vue?vue&type=script&lang=js&"
import style0 from "./PaymentChoice.vue?vue&type=style&index=0&id=304e7888&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304e7888",
  null
  
)

export default component.exports